import { ReplaceTextBlock } from "./LLM/ReplaceText";
import { CollapseBlock } from "./LLM/Collapse";
import { BlockMatch, FallbackComponent, CustomBlock, hideJsonBlocks } from "../../lib/llm-ui";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";

export const textUpdateBlock: CustomBlock = {
  startChar: "【",
  endChar: "】",
  type: "replace-text",
  visibleIfPartial: false,
  component: ReplaceTextBlock,
};

export const collapseBlock: CustomBlock = {
  startChar: "【",
  endChar: "】",
  type: "collapse",
  visibleIfPartial: true,
  component: CollapseBlock,
};

export const markdownBlock: FallbackComponent = ({ blockMatch }: { blockMatch: BlockMatch }) => (
  <div className="prose max-w-none">
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{hideJsonBlocks(blockMatch.output)}</ReactMarkdown>
  </div>
);
